// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"767":"931ea3fb","877":"949b793a"}[chunkId] + ".chunk.js";
};